<script setup lang="ts">
import { inject, ref, watch } from 'vue'
import IconShareVariant from '~icons/mdi/share-variant'
import IconOverscan from '~icons/mdi/overscan'
import vuetifyLogo from '../assets/vuetify-logo-v3-light.svg'
import { State } from '../composables/store'
import { useAlert } from '../composables/alert'

const props = defineProps<{
  state: State,
}>()

const versions = inject('versions') as Record<'vue' | 'vuetify' | 'vuetifyNightly', string[]>

const vueVersions = versions.vue
const vuetifyVersions = ref(props.state.nightly.value ? versions.vuetifyNightly : versions.vuetify)

watch(props.state.nightly, nightly => {
  vuetifyVersions.value = nightly ? versions.vuetifyNightly : versions.vuetify
  props.state.vuetifyVersion.value = vuetifyVersions.value[0]
})

const { alert } = useAlert()

async function copyLink () {
  await navigator.clipboard.writeText(location.href)
  alert('Sharable URL has been copied to the clipboard')
}

function fullscreenPreview () {
  location.href = `?preview=true${location.hash}`
}
</script>

<template>
  <v-app-bar elevation="1">
    <img
      class="ml-2"
      :src="vuetifyLogo"
      height="32"
    >
    <v-app-bar-title class="ml-4">
      <a href="/" class="text-decoration-none on-surface">Vuetify Playground</a>
    </v-app-bar-title>
    <v-spacer />
    <v-select
      v-model="props.state.vueVersion.value"
      label="Vue version"
      :items="vueVersions"
      hide-details
      density="compact"
      variant="outlined"
      class="pr-4"
      :menu-props="{ maxHeight: 450 }"
      style="flex: none; width: 250px"
    />
    <v-select
      v-model="props.state.vuetifyVersion.value"
      label="Vuetify version"
      :items="vuetifyVersions"
      hide-details
      density="compact"
      variant="outlined"
      class="pr-4"
      :menu-props="{ maxHeight: 450 }"
      style="flex: none; width: 250px"
    >
      <template #prepend-item>
        <v-switch
          v-model="props.state.nightly.value"
          hide-details
          label="NIGHTLY"
          color="primary"
          class="mx-4"
          @click.stop
          @mousedown.stop.prevent
          @mouseup.stop.prevent
        />
        <v-divider />
      </template>
    </v-select>
<!--    <v-switch
      v-model="props.state.ssr.value"
      hide-details
      label="SSR"
      color="primary"
      class="flex-grow-0 mx-2"
    />-->
    <v-btn
      :icon="IconOverscan"
      size="small"
      @click="fullscreenPreview"
    />
    <v-tooltip location="bottom">
      <template #activator="{ props: activatorProps }">
        <v-btn
          v-bind="activatorProps"
          :icon="IconShareVariant"
          size="small"
          @click="copyLink"
        />
      </template>
      Sharable link
    </v-tooltip>
  </v-app-bar>
</template>
